import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {PathUrlEnum} from '../../../utils/analytics.utils';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataPersonalSellerPf} from '../../../shared/models/SellerPf.model';
import {EstadoCivil} from "../../../shared/enums/estadoCivil.enum";
import CpfHelper from "../../../helpers/cpf.helper";

@Component({
  selector: 'app-seller-resume-pf',
  templateUrl: './seller-resume-pf.component.html',
  styleUrls: ['./seller-resume-pf.component.scss'],
})
export class SellerResumePfComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();
  @Output() dataForms = new EventEmitter();
  @Input() dataPersonal: DataPersonalSellerPf;
  declarationForm: FormGroup;
  cep = '00000-000';
  cpf = '999.999.999-99';
  phone = '(99)99999-9999';
  conta = '00000000-0';
  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(private analyticsService: AnalyticsService) {
  }

  ngOnInit(): void {
    this.initForm();
    this.isFormComplete();
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PF_RESUMO);
  }

  initForm() {
    this.declarationForm = new FormGroup({
      hasDeclaration: new FormControl(false, [Validators.requiredTrue]),
    });

    //solucao bug ios
    this.declarationForm.get('hasDeclaration')?.markAsPristine();
    this.declarationForm.get('hasDeclaration')?.markAsTouched();
    this.declarationForm.get('hasDeclaration')?.markAsDirty();
  }

  get hasError(): boolean {
    return (
      ((this.declarationForm.get('hasDeclaration')?.dirty ||
          this.declarationForm.get('hasDeclaration')?.touched) &&
        this.declarationForm.get('hasDeclaration')?.invalid) ??
      false
    );
  }

  get hasMarried(): boolean {
    return this.dataPersonal.relationship.maritalStatus === EstadoCivil.CASADO;
  }

  isFormComplete() {
    this.declarationForm.statusChanges.subscribe(newStatus => {
      Object.keys(this.declarationForm.controls).forEach(key => {
        this.dataPersonal[key] = this.declarationForm.get(key)?.value;
      });
      this.formsComplete.emit(newStatus.toLowerCase() === 'valid');
      this.dataForms.emit(this.dataPersonal);
    });
  }
}
